import React, { useEffect, useState } from "react"
import styles from "@/components/Remedy/components/HeroBlockSection/components/HeroBlockText/HeroBlockText.module.scss"
import { Button, Typography } from "@kohler-dsm-library/kohler-core"
import { handleRegisterPreorderAnalytics } from "@/components/Remedy/components/analytics"

export const HeroBlockText = ({ pdpUrl = "", ctaTitle = "" }) => {
  const [opacity, setOpacity] = useState(0)

  const handleScrollOpacity = () => {
    if (window.scrollY > window.innerHeight / 5) {
      setOpacity(0)
    } else {
      setOpacity(1)
    }
  }

  useEffect(() => {
    setOpacity(1)
    window.addEventListener("scroll", handleScrollOpacity)

    return () => {
      window.removeEventListener("scroll", handleScrollOpacity)
    }
  }, [])

  return (
    <div className={styles["hero-block-text"]} style={{ opacity: opacity }}>
      <div className={styles["__content"]}>
        <img
          src="/content/dam/remedy-assets/Colab.png"
          className={styles["__colab-image"]}
          width="294"
          alt="Colab"
        />
        <div className={styles["__text-content"]}>
          <Typography
            className={styles["__title"]}
            mod="charcoal"
            component="h1"
            size="h1"
          >
            Ice Bath by Remedy Place
          </Typography>
          <Typography
            className={styles["__subtitle"]}
            component="span"
            size="label-regular-xl"
          >
            A New Dimension of Self Care
          </Typography>
        </div>
        <Button
          component="a"
          href={pdpUrl}
          size="small"
          target="_blank"
          onClick={() =>
            handleRegisterPreorderAnalytics(
              "Ice Bath by Remedy Place A New Dimension of Self Care",
              ctaTitle,
              pdpUrl
            )
          }
        >
          {ctaTitle}
        </Button>
      </div>
    </div>
  )
}
